import { useEffect, useState } from 'react';
export const useAnalyticsReportsData = () => {
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (isLoading) {
            setTimeout(() => setIsLoading(false), 500);
        }
    }, [isLoading]);
    const data = [
        {
            id: 'conversion-rate',
            name: 'Conversion rate',
            externalSource: 'googleAnalytics',
        },
        {
            id: 'visitors',
            name: 'Visitors',
            externalSource: 'googleAnalytics',
        },
        {
            id: 'sales-by-traffic-source',
            name: 'Sales by traffic source',
            externalSource: 'googleAnalytics',
        },
        {
            id: 'sessions-by-traffic-source',
            name: 'Sessions by traffic source',
            externalSource: 'googleAnalytics',
        },
        {
            id: 'sales-by-social-source',
            name: 'Sales by social source',
            externalSource: 'googleAnalytics',
        },
        {
            id: 'sessions-by-social-source',
            name: 'Sessions by social source',
            externalSource: 'googleAnalytics',
        },
        {
            id: 'total-profit',
            name: 'Total profit',
        },
        {
            id: 'shop-profit',
            name: 'Shop profit',
            downloadEnabled: false,
        },
        {
            id: 'memberships-profit',
            name: 'Memberships profit',
        },
        {
            id: 'shop-orders',
            name: 'Shop orders',
        },
        {
            id: 'average-shop-order-value',
            name: 'Average shop order value',
        },
        {
            id: 'top-products-by-units-sold',
            name: 'Top products by units sold',
        },
        {
            id: 'sales-by-country',
            name: 'Sales by country',
        },
        {
            id: 'total-members',
            name: 'Total members',
        },
        {
            id: 'memberships-transactions',
            name: 'Memberships transactions',
        },
        {
            id: 'members-change',
            name: 'Members change',
        },
        {
            id: 'free-accounts',
            name: 'Free accounts',
        },
        {
            id: 'free-accounts-change',
            name: 'Free accounts change',
        },
        {
            id: 'top-tiers-by-members',
            name: 'Top tiers by members',
        },
        {
            id: 'payment-method-used',
            name: 'Payment method used',
        },
        {
            id: 'customers-over-time',
            name: 'Customers over time',
        },
        {
            id: 'sales-over-time',
            name: 'Sales over time',
        },
        {
            id: 'sales-over-time-detailed',
            name: 'Sales over time (detailed)',
        },
        {
            id: 'sales-over-time-donations',
            name: 'Sales over time (donations)',
        },
        {
            id: 'sales-over-time-memberships',
            name: 'Sales over time (memberships)',
        },
        {
            id: 'sales-over-time-orders',
            name: 'Sales over time (orders)',
        },
    ];
    const handleDownload = async (reportId) => {
        console.log('download', reportId);
        // Delay for loading
        await new Promise((resolve) => {
            setTimeout(() => resolve(), 1000);
        });
    };
    return {
        data,
        isLoading,
        onDownload: handleDownload,
    };
};
